import React from 'react';

export function PageCard({
    title,
    description,
    actions,
    children,
    className = '',
}) {
    const hasHeader = title || description || actions;

    return (
        <section className={`private-page-card ${className}`.trim()}>
            {hasHeader ? (
                <div className={`private-page-card-header${actions ? ' private-page-card-header--split' : ''}`.trim()}>
                    <div>
                        {title ? <h2 className="private-page-card-title">{title}</h2> : null}
                        {description ? <p className="private-page-card-text">{description}</p> : null}
                    </div>
                    {actions ? <div className="private-page-card-toolbar">{actions}</div> : null}
                </div>
            ) : null}
            {children}
        </section>
    );
}

export default PageCard;